import { Icon } from "@components/icon";
import * as types from "@root/types";
import React, { FC, useEffect, useMemo, useState } from "react";

type FlashType = "notice" | "warning" | "error";

interface FlashMessageProps {
  type?: FlashType;
  message: string | string[];
  durationMilliseconds?: number;
}

const FLASH_ICON_LOOKUP: Record<FlashType, types.IconName> = {
  notice: "info",
  warning: "info",
  error: "flash_on",
};

const FlashMessage: FC<FlashMessageProps> = ({
  type = "notice",
  message,
  durationMilliseconds,
}) => {
  const id = `flash--${type}`;
  const iconClass = FLASH_ICON_LOOKUP[type];
  const classes = `flash--${type} flash-wrapper`;
  const [visible, setVisible] = useState<boolean>(true);

  useEffect(() => {
    if (!durationMilliseconds || durationMilliseconds > 0) {
      const timeout = setTimeout(
        () => setVisible(false),
        durationMilliseconds || 5000,
      );
      return () => clearTimeout(timeout);
    }
  }, [durationMilliseconds]);

  const handleClick = () => {
    setVisible(false);
  };

  const messages = useMemo(() => {
    const msgs = new Set(Array.isArray(message) ? message : [message]);
    return Array.from(msgs.values()).map((msg) => <div key={msg}>{msg}</div>);
  }, [message]);

  if (!visible) {
    return null;
  }
  return (
    <div id={id} className={classes} onClick={handleClick}>
      <div className="flash--icon">
        <Icon name={iconClass} />
      </div>

      <div className="flash--message">{messages}</div>
      <div className="flash--close">
        <Icon ariaLabel="Close" name="cross" />
      </div>
    </div>
  );
};

export { FlashMessage, FlashMessageProps };
